import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, onUnmounted, ref } from 'vue';
import moment from 'moment';
import { staticDataService } from '../main';
import { ArtemisBlogItem, isArtemisBlog, isServiceLoading, isServiceSuccess, ServiceResult } from '@/data.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'artemis-blog',
  setup(__props) {

function time(val: string) {
  return moment.utc(val).format("ddd, DD.MM, HH:mm z");
}
function formatDescription(val: string) {
  return val.replace(/ \[(\.{3}|…|&#8230;)\].?$/, "")
}

let data = ref<ServiceResult>({ error: new Error("No data yet.") });
let updateDataInterval: number;
const dialog = ref(false);

function updateData() {
  data.value = { ...data.value, loading: true };
  staticDataService.getArtemisBlog().then((newData) => {
    data.value = newData;
  });
}

onMounted(() => {
  updateDataInterval = setInterval(updateData, 5 * 60 * 1000);
  updateData();
})
onUnmounted(() => {
  if (updateDataInterval) clearInterval(updateDataInterval)
})

const lastitem = computed<ArtemisBlogItem>(() => {
  if (isServiceSuccess(data.value)) {
    if (isArtemisBlog(data.value.data)) {
      return data.value.data.data.entries.at(0) || { description: "Empty list received..." } as ArtemisBlogItem;
    } else {
      return {
        description: "Invalid data received"
      } as ArtemisBlogItem
    }
  }
  else if (isServiceLoading(data.value)) {
    return {
      description: "Loading..."
    } as ArtemisBlogItem
  } else {
    return {
      description: `Error "${data.value.error.name}": ${data.value.error.message}`,
    } as ArtemisBlogItem
  }
})

const content = computed<string>(() => {
  let content = lastitem.value.content || ""
  content = content.replace(/width="\d+"/g, "")
  content = content.replace(/height="\d+"/g, "")
  content = content.replace(/style="width: \d+px"/g, "")

  content = `${content}
  
  <style>
    /* Styles from NASA's original page */
    .hds-media-wrapper .hds-media-ratio-cover img {
      transition: all .4s ease;
    }
    /* Important for the scaling of the image */
    .hds-media .hds-media-inner {
      width: 100%;
      height: 100%;
      display: flex;
      overflow: hidden;
    }
    .wp-block-image img {
      box-sizing: border-box;
      height: auto;
      max-width: 100%;
      vertical-align: bottom;
    }
    
    .hds-caption, .hds-caption-credits, .hds-caption-text {
      font-size: .75rem;
      line-height: 1.25rem;
      display: block;
      width: 100%;
      text-align: left;
      /* from vuetify's text-medium-emphasis */
      color: rgba(var(--v-theme-on-background),var(--v-medium-emphasis-opacity)) !important;
    }
    .hds-credits {
      font-size: .75rem;
      line-height: 1.25rem;
      text-align: right; /* Own customization */
      /* from vuetify's text-medium-emphasis (reset) */
      color: rgb(var(--v-theme-on-background))
    }
  </style>
  `

  return content
})

return { __sfc: true,time, formatDescription, data, updateDataInterval, dialog, updateData, lastitem, content, isServiceLoading }
}

})